import React, { useEffect, useState } from 'react'
import { collection, getCountFromServer, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../../../../../firebase';
import { useAuth } from '../../../../../../context/AuthContext';

const BookedUnitCount = ({ propID, unitID }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [totalCount, setTotalCount] = useState(0);

  async function getTotalBookedUnitCount(propID) {
    const q = query(collection(db, "Businesses", bid, "Properties", propID, "BookedUnits"), where("unitID", "==", unitID));
    const snapshot = await getCountFromServer(q);
    setTotalCount(snapshot.data().count);
  }

  useEffect(() => {
    getTotalBookedUnitCount(propID);
  }, [])

  return `${totalCount}`;
}

export default BookedUnitCount;
